/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Green_Eagle_StirInputs */

const en_green_green_eagle_stir = /** @type {(inputs: Green_Green_Eagle_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. answers`)
};

const de_green_green_eagle_stir = /** @type {(inputs: Green_Green_Eagle_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestantworten`)
};

/**
* | output |
* | --- |
* | "Min. answers" |
*
* @param {Green_Green_Eagle_StirInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_green_eagle_stir = /** @type {((inputs?: Green_Green_Eagle_StirInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Green_Eagle_StirInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_green_eagle_stir(inputs)
	return de_green_green_eagle_stir(inputs)
});